<template>
  <h1></h1>
</template>

<script>
export default {
  name: "ProjectList"
};
</script>

<style scoped>
</style>
